export default __webpack_public_path__ + "static/img3-aa6899af5dc1abc0e8105e435c3918d5.png";